
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/form/marquee/[urlSlug]",
      function () {
        return require("private-next-pages/form/marquee/[urlSlug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/form/marquee/[urlSlug]"])
      });
    }
  